import Service from "../../../Services/index";
import moment from "moment";

const Order = {
    namespaced: true,
    state: {
        status_create_invoice: null,
        orderForm: {
            customer: null,
            transportation: null,
            transport_type: null,
            transport_type_name: "",
            customer_transport_form: [],
            details: [],
            status: 1,
            date: "",
            transport_type_id: null,
            note: null,
            status_have_old: false,
            status_payment: false,
            status_transport_other: false,
            customer_other: null,
            customer_other_id: "",
            other_price: "",
            other_price_form: null,
            remark: "",
            status_return: null,
            status_confirm: null,
            status_before_transport: null,
            status_tax_receipt: null,
            user_id: "",
            status_receive: null,
            discount_special: "",
            other_discount: '',
            other_discount_user: '',
            order_transport_details: [],
            temp_order_transport_details: [],
            status_foam_discount: false,
            status_glass_discount: false,
            status_not_pay: false,
            status_sale_receive: false,
            note_2: ''
        },
        search: {
            order_id: "",
            date: [],
            status: "",
            transport_type: "",
            sale: "",
            customer: "",
            product: null,
            product_type_id: '',
        },
        promotion_detail: null,
        product_promotion_other: [],
        max_discount: 0,
        discount_price: [
            {value: null, text: "เลือกราคาลดพิเศษ"},
            {value: 1, text: "+1"},
            {value: 2, text: "+2"},
            {value: 3, text: "+3"},
            {value: 4, text: "+4"},
            {value: 5, text: "+5"},
        ],
        search_order: {
            sale: null,
            customer: null,
            date: "",
            month: "",
            year: "",
            range: null,
        },
        check_freez: null,
        tuyen: null,
        old_id_for_new_do: null
    },
    mutations: {
        SET_ORDER_FORM: (state, res) => {
            state.orderForm = res;
        },
        SET_ORDER_FORM_NEWDO: (state, res) => {
            res.details = res.details.filter(x => {
                return x.quantity > 0
            })
            state.orderForm = res;
        },
        GET_PROMOTION: (state, res) => {
            state.promotion_detail = res;
        },
        GET_PROMOTION_DETAILS: (state, res) => {
            state.orderForm.details = res;
        },
        SET_DETAILS: (state, res) => {
            if (res.length > 0) {
                state.orderForm.details = res;
            }
        },
        SET_PRODUCT_PROMOTION_OTHER: (state, res) => {
            state.product_promotion_other = res.product;
            state.max_discount = res.max_discount;
        },
        CLEAR_FORM_DATA: (state, order_number) => {
            const currentDate = moment().format("YYYY-MM-DD");
            state.orderForm = {
                id: '',
                order_id: order_number,
                customer: null,
                transportation: null,
                transport_type: null,
                details: [],
                status: 1,
                date: currentDate,
                transport_type_id: null,
                customer_transport_form: [],
                note: null,
                status_have_old: false,
                status_payment: false,
                status_transport_other: false,
                customer_other: null,
                customer_other_id: "",
                other_price: "",
                other_price_form: null,
                remark: "",
                status_return: null,
                transport_type_name: "",
                status_confirm: null,
                status_before_transport: null,
                status_tax_receipt: null,
                status_receive: null,
                discount_special: "",
                user_id: "",
                order_transport_details: [],
                temp_order_transport_details: [],
                other_discount: '',
                other_discount_user: '',
                status_foam_discount: false,
                status_glass_discount: false,
                status_not_pay: false,
                status_sale_receive: false,
            };
            state.product_promotion_other = [];
            state.max_discount = [];

        },
        ADD_PRODUCT: (state, data) => {
            state.orderForm.details = [
                ...state.orderForm.details,
                {
                    ...data
                }
            ];
        },
        ADD_STATUS: (state, data) => {
            state.orderForm.details = [
                ...state.orderForm.status,
                {
                    ...data
                }
            ];
        },
        REMOVE_PRODUCT: (state, index) => {
            state.orderForm.details = state.orderForm.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                order_id: "",
                date: [],
                status: "",
                transport_type: "",
                sale: "",
                customer: "",
                product: "",
                product_type_id: "",
            },
                state.search_order = {
                    customer: null,
                    date: "",
                    month: "",
                    year: "",
                    range: null,
                }
        },
        GET_DISCOUNT_PRICE: (state) => {
            state.discount_price = [
                {value: 0, text: "เลือกราคาลดพิเศษ"},
                {value: 1, text: "-1"},
                {value: 2, text: "-2"},
                {value: 3, text: "-3"},
                {value: 4, text: "-4"},
                {value: 5, text: "-5"},
            ];
        },
        SET_STATUS_CREATE_INVOICE: (state, res) => {
            state.status_create_invoice = res;
        },
        FILTER_OPTION: (state, check) => {
            if (check.check && !check.tuyen) {
                state.orderForm.details = state.orderForm.details.filter(
                    detail => detail.product.product_type_id == 14 || detail.product.product_type_id == 17
                );
            }
        },
        ONLY_FREEZ: (state, {check, tuyen}) => {
            state.check_freez = check;
            state.tuyen = tuyen;
        },
        CLEAR_ONLY_FREEZ: (state) => {
            state.check_freez = null;
            state.tuyen = null;
        },
        CLEAR_ONLY_NEW_DO: (state, res) => {
            const currentDate = moment().format("YYYY-MM-DD");
            state.old_id_for_new_do = res.oldID;
            state.orderForm.order_id = res.order_id;
            state.orderForm.order_status_id = null;
            state.orderForm.date = currentDate;
            state.orderForm.transport_type = null;
            state.orderForm.transportation = null;
            state.orderForm.details.forEach((x, i) => {
                x.remaining = x.quantity;
                x.total_quantity_order = x.quantity;
                x.total = x.price * x.quantity;
            })
        },
        SET_NEW_PRICE: (state, res) => {
            state.orderForm.details.forEach((x, i) => {
                x.price = res[x.product_id];
            })
        },
    },
    actions: {
        update_check_freez({commit}, {check, tuyen}) {
            commit('ONLY_FREEZ', {check, tuyen})
            return {check, tuyen};
        },
        clear_check_freez({commit}) {
            commit('CLEAR_ONLY_FREEZ')
        },
        clear_new_do({commit, state}, oldID) {
            let id = '';
            state.orderForm.details.forEach((x, i) => {
                if (i > 0) id += ',' + x.product_id;
                else id += x.product_id;
            });
            Service.order.getNewPrice(id).then(res => {
                commit('SET_NEW_PRICE', res)
                Service.order.generateDO().then(res => {
                    commit('CLEAR_ONLY_NEW_DO', {order_id: res, oldID: oldID})
                });
            })

        },
        filter_option({commit}, check) {
            commit('FILTER_OPTION', check)
        },
        setOrders({commit},page = 1) {
            return Service.order.getOrder(page);
        },
        allOrderOption({commit},searchQuery) {
            return Service.order.allOrderOption(searchQuery);
        },
        setOrderForm({commit}, data) {
            commit("SET_ORDER_FORM", data);
        },
        showOrder({commit}, id) {
            return Service.order.showOrder(id).then(response => {
                if (response[0] != false) {
                    commit("SET_ORDER_FORM", response);
                }
                return response;
            });
        },
        checkOrderIsValid({commit},id) {
            return Service.order.checkOrder(id).then(response => {
                return response;
            });
        },
        showOrderNewDO({commit}, id) {
            return Service.order.showOrder(id).then(response => {
                if (response[0] != false) {
                    commit("SET_ORDER_FORM_NEWDO", response);
                }
                return response;
            });
        },
        clearFormData({commit}) {
            return Service.order.generateDO().then(res => {
                commit('CLEAR_FORM_DATA', res);
            });
        },
        addProduct({commit}, data) {
            commit("ADD_PRODUCT", data);
        },
        addOrderStatus({commit}, data) {
            commit("ADD_STATUS", data);
        },
        removeProduct({commit}, index) {
            commit("REMOVE_PRODUCT", index);
        },
        createInvoiceFromOrder({commit, dispatch, state}, order_id) {
            let details = [];
            return Service.order.orderProductForOpenInvoice(order_id).then(order_details => {
                if (order_details) {
                    order_details.forEach(detail => {
                        if (detail.quantity > 0 && detail.product) {
                            details.push(detail);
                        }
                    });
                    dispatch(
                        "Invoice/setInvoice",
                        {
                            customer: state.orderForm.customer,
                            order_id: state.orderForm.id,
                            details: details,
                            order_number: state.orderForm.order_id,
                            status: null,
                            status_have_old: state.orderForm.status_have_old,
                            status_payment: state.orderForm.status_payment,
                            status_transport_other: state.orderForm.status_transport_other,
                            other_price_form: state.orderForm.other_price_form,
                            other_price: state.orderForm.other_price,
                            customer_other: state.orderForm.customer_other,
                            remark: state.orderForm.remark,
                            status_return: state.orderForm.status_return,
                            transportation: state.orderForm.transportation,
                            transportation_id: state.orderForm.transportation_id,
                            transport_type_name: state.orderForm.transport_type_name,
                            transport_type_id: state.orderForm.transport_type_id,
                            status_confirm: state.orderForm.status_confirm,
                            status_before_transport: state.orderForm.status_before_transport,
                            status_tax_receipt: state.orderForm.status_tax_receipt,
                            status_receive: state.orderForm.status_receive,
                            discount_special: state.orderForm.discount_special,
                            order_transport_details: state.orderForm.order_transport_details,
                            other_discount: state.orderForm.other_discount,
                            other_discount_user: state.orderForm.other_discount_user,
                            status_foam_discount: state.orderForm.status_foam_discount,
                            status_glass_discount: state.orderForm.status_glass_discount,
                            status_not_pay: state.orderForm.status_not_pay,
                            status_sale_receive: state.orderForm.status_sale_receive,
                            other_discount_user_model: state.orderForm.other_discount_user_model
                        },
                        {root: true}
                    );
                }
                commit('SET_STATUS_CREATE_INVOICE', order_details)
            })
        },
        save({commit, state}, {id, newDO = null}) {
            const data = {
                customer_id: "",
                sale_id: "",
                transport_type_id: "",
                transportation_id: "",
                order_status_id: 1,
                date: state.orderForm.date,
                order_id: "",
                details: state.orderForm.details.map(detail => ({
                    ...detail,
                    product_id: detail.product ? detail.product.id : null
                })),
                note: state.orderForm.note,
                status_have_old: state.orderForm.status_have_old,
                status_payment: state.orderForm.status_payment,
                status_transport_other: state.orderForm.status_transport_other,
                other_price: state.orderForm.other_price,
                other_price_form: state.orderForm.other_price_form,
                customer_other_id: state.orderForm.customer_other_id,
                remark: state.orderForm.remark,
                status_return: state.orderForm.status_return,
                status_confirm: state.orderForm.status_confirm,
                status_before_transport: state.orderForm.status_before_transport,
                status_tax_receipt: state.orderForm.status_tax_receipt,
                status_receive: state.orderForm.status_receive,
                discount_special: state.orderForm.discount_special,
                other_discount: state.orderForm.other_discount,
                other_discount_user: state.orderForm.other_discount_user,
                user_id: state.orderForm.user_id,
                order_transport_details: state.orderForm.order_transport_details,
                temp_order_transport_details: state.orderForm.temp_order_transport_details,
                status_foam_discount: state.orderForm.status_foam_discount,
                status_glass_discount: state.orderForm.status_glass_discount,
                status_not_pay: state.orderForm.status_not_pay,
                status_sale_receive: state.orderForm.status_sale_receive,
                newDO: newDO,
                old_id_for_new_do: state.old_id_for_new_do,
            };
            //transportation
            if (state.orderForm.transportation !== null) {
                data.transportation_id = state.orderForm.transportation.id
            }
            //customer
            if (state.orderForm.customer) {
                data.customer_id = state.orderForm.customer.id;
            }
            //sale
            if (state.orderForm.customer && state.orderForm.customer.sale) {
                data.sale_id = state.orderForm.customer.sale.id;
            }
            //transport_type
            if (state.orderForm.transport_type) {
                data.transport_type_id = state.orderForm.transport_type.id;
            }
            if (!id) {//create
                return Service.order.createOrder(data);
            } else {
                data.order_id = state.orderForm.order_id;
                data.order_status_id = state.orderForm.order_status_id;
                return Service.order.updateOrder(id, data);
            }
        },
        delete({commit}, id) {
            return Service.order.deleteOrder(id);
        },
        search({commit}, {page = "", search}) {
            return Service.order.searchOrder(page, search)
        },
        promotionOrder({commit}, data) {
            return Service.order.PromotionOrder(data).then(res => {
                commit("GET_PROMOTION", res);
            })
        },
        promotionOrderMultiple({commit}, data) {
            return Service.order.PromotionOrderMultiple(data).then(res => {
                commit("GET_PROMOTION_DETAILS", res);
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        clearForm({commit}) {
            commit("CLEAR_FORM");
        },
        getOrderBefore({commit}, data) {
            return Service.order.getOrderBefore(data.customer_id, data.transport_type_id).then(res => {
                // commit("SET_DETAILS",res);
            });
        },
        //promotion other
        getProductByPromotionOther({commit}, sale_id) {
            return Service.order.getProductByPromotionOther(sale_id).then(res => {
                commit("SET_PRODUCT_PROMOTION_OTHER", res);
            })
        },
        setDiscountPrice({commit}) {
            commit("GET_DISCOUNT_PRICE")
        },
        changeStatusOrder({commit}, data) {
            return Service.order.changeStatusOrder(data);
        },
        getOrderTransportPrice({commit}, data) {
            return Service.order.getOrderTransportPrice(data);
        },
        addNote({commit}, id) {
            return Service.order.addNote(id)
        },
    }
};

export default Order;
